/**
 * @param {{eyebrow: string, title: string, description?: string, align?: "left" | "center"}} props
 */
export function SectionHeader({ eyebrow, title, description, align = "left" }) {
  const alignment = align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl";
  return `
    <div class="${alignment}">
      <span class="eyebrow">${eyebrow}</span>
      <h2 class="section-title">${title}</h2>
      ${description ? `<p class="section-description">${description}</p>` : ""}
    </div>
  `;
}
